import { render, staticRenderFns } from "./GeneralPanel.vue?vue&type=template&id=3508fc90&scoped=true&"
import script from "./GeneralPanel.vue?vue&type=script&lang=js&"
export * from "./GeneralPanel.vue?vue&type=script&lang=js&"
import style0 from "./GeneralPanel.vue?vue&type=style&index=0&id=3508fc90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3508fc90",
  null
  
)

export default component.exports